export const routes = {
  home: '/',
  login: '/auth/login',
  resetPassword: '/auth/reset-password',
  forgotPassword: '/auth/forgot-password',
  profile: '/dashboard/profile',
  settings: '/dashboard/settings',
  submitData: '/dashboard/submit-data',
  reports: '/dashboard/reports',
  userAccounts: '/dashboard/user-accounts',
  holdCo: '/dashboard/holdco',
  dashboard: '/dashboard',
};
